// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.f8df93dd609b23b1143ba7fe350d18d3985f10f6.js";
};